import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import './pageEnter.css';

/**
 * Wraps a layout's `<Outlet />` so each page enters with the one page
 * transition the console has (`pageEnter.css`): opacity and 6px of rise,
 * 180ms, enter only.
 *
 * Keyed on the **pathname only**. A tab (`?tab=`), a filter, a page of a
 * list or an open drawer lives in the query string, and changing it must not
 * remount the page — that would replay the animation and throw away the
 * page's local state. A new path is a new page and mounts fresh.
 *
 * It sits inside the layout's `Suspense`, so while a lazy route is loading
 * the fallback (the loader, the route bar) shows and this element is not in
 * the document; the animation runs when the page itself mounts.
 */
export function PageEnter({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  return (
    <div key={pathname} className="uw-page-enter" data-testid="page-enter">
      {children}
    </div>
  );
}
